/* D Byk — filter drawer accordion + cart drawer intro.
 *
 * Filters: the theme's <menu-drawer> slides each filter in as its own screen.
 * We catch clicks on filter headings first (document, capture phase), stop the
 * theme's slide handler, and open/close the filter in place with a height
 * animation. Applying filters, clearing, counts and re-rendering are all still
 * done by the theme's facets.js.
 *
 * Cart: adds a short-lived data-db-intro attribute when the drawer opens so the
 * rows cascade in once, not on every quantity change.
 */
(function () {
  'use strict';
  if (window.__dbykDrawers) return;
  window.__dbykDrawers = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var EASE = 'cubic-bezier(0.3, 0.7, 0.2, 1)';

  function setExpanded(details, open) {
    var summary = details.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function toggleFilter(details, open) {
    var panel = details.querySelector(':scope > .mobile-facets__submenu');

    if (details._dbAnim) {
      details._dbAnim.cancel();
      details._dbAnim = null;
    }
    details.classList.remove('dbf-closing');
    setExpanded(details, open);

    if (!panel || reduceMotion.matches || typeof panel.animate !== 'function') {
      details.open = open;
      return;
    }

    if (open) {
      details.open = true;
      var target = panel.scrollHeight;
      var anim = panel.animate(
        [
          { height: '0px', opacity: 0 },
          { height: target + 'px', opacity: 1 },
        ],
        { duration: 380, easing: EASE }
      );
      details._dbAnim = anim;
      anim.onfinish = function () {
        details._dbAnim = null;
      };
    } else {
      var start = panel.offsetHeight;
      details.classList.add('dbf-closing');
      var closeAnim = panel.animate(
        [
          { height: start + 'px', opacity: 1 },
          { height: '0px', opacity: 0 },
        ],
        { duration: 300, easing: EASE }
      );
      details._dbAnim = closeAnim;
      closeAnim.onfinish = function () {
        details.open = false;
        details.classList.remove('dbf-closing');
        details._dbAnim = null;
      };
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!event.target || !event.target.closest) return;
      var summary = event.target.closest('#FacetFiltersFormMobile details.mobile-facets__details > summary');
      if (!summary) return;

      event.preventDefault();
      event.stopPropagation();

      var details = summary.parentElement;
      var opening = !details.open || details.classList.contains('dbf-closing');
      toggleFilter(details, opening);
    },
    true
  );

  function watchCart() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer._dbWatched) return;
    drawer._dbWatched = true;

    var wasActive = drawer.classList.contains('active');
    new MutationObserver(function () {
      var isActive = drawer.classList.contains('active');
      if (isActive && !wasActive) {
        drawer.setAttribute('data-db-intro', '');
        clearTimeout(drawer._dbIntroTimer);
        drawer._dbIntroTimer = setTimeout(function () {
          drawer.removeAttribute('data-db-intro');
        }, 1000);
      }
      wasActive = isActive;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCart);
  } else {
    watchCart();
  }
})();
